import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { DragEventSeparator as t } from "../../../input/DragEventSeparator.js";
import { InputHandler as a } from "../../../input/InputHandler.js";
import { eventMatchesPointerAction as i } from "../../../input/handlers/support.js";

var o = /*#__PURE__*/function (_a) {
  _inherits(o, _a);

  var _super = _createSuper(o);

  function o(a, _o, r) {
    var _this;

    _classCallCheck(this, o);

    _this = _super.call(this, !0), _this.view = a, _this.pointerAction = _o;
    var e = _this.view.mapViewNavigation;
    _this.dragEventSeparator = new t({
      start: function start(t, a) {
        e.rotate.begin(_this.view, a.data), a.stopPropagation();
      },
      update: function update(t, a) {
        e.rotate.update(_this.view, a.data), a.stopPropagation();
      },
      end: function end(t, a) {
        e.rotate.end(), a.stopPropagation();
      },
      condition: function condition(t, a) {
        return 1 === t && i(a.data, _this.pointerAction);
      }
    }), _this.registerIncoming("drag", r, function (t) {
      return _this.dragEventSeparator.handle(t);
    });
    return _this;
  }

  return o;
}(a);

export { o as DragRotate };